export default {
    Id: 0,

    Name: '',
    FirstName: '',
    MiddleName: '',

    NameLat: '',
    FirstNameLat: '',
    MiddleNameLat: '',

    Code: '',
    CitizenId: '',
    Constant: false,

    Birthday: '',
    Gender: 0,
    AgeCategory: 0,

    Comment: '',

    PassportRusSer: '',
    PassportRusNumber: '',
    PassportRusDate: '',
    PassportRusByWhom: '',

    PassportType: '',
    PassportNumber: '',
    PassportDate: '',
    PassportDateEnd: '',
    PassportByWhom: '',

    PostIndex: '',
    PostArea: '',
    PostCity: '',
    PostStreet: '',
    PostCountry: '',
    PostDistrict: '',
    PostBuilding: '',
    PostFlat: '',

    Phone: '',
    mobile: '',
    Mobile_CC: '',
    Mobile_RG: '',
    Mobile_Number: '',
    Fax: '',
    Email: '',
    IsSendSMS: false,
    IsSendEmail: false,

    BirthCountry: '',
    BirthCity: '',
    BirthArea: '',
    BirthDistrict: '',
    Family: '',
}